import React, { useEffect } from "react";
import $ from "jquery";

const Catalog = (props) => {
  // useEffect(() => {
  //   // Update the document title using the browser API
  //
  //   $(document).on("click", "#hide_menu", function () {
  //     $("#menu-left").css({ width: "10%" });
  //     $("#content-mid").css({ width: "85%" });
  //     $(".left-menu a").css({
  //       "font-size": "0px",
  //       padding: "10px 30px",
  //       width: "70px",
  //     });
  //     $("#hide_menu, #show_menu").toggle();
  //     $(".tree").attr("hidden", "true");
  //   });
  //
  //   $(document).on("click", "#show_menu", function () {
  //     $("#menu-left").css({ width: "20%" });
  //     $("#content-mid").css({ width: "75%" });
  //     $(".left-menu a").css({
  //       "font-size": "18px",
  //       padding: "10px 25px 10px 70px",
  //       width: "auto",
  //     });
  //     $("#hide_menu, #show_menu").toggle();
  //     $(".tree").removeAttr("hidden");
  //   });
  // });

  function hide(){
    $("#menu-left").css({ width: "10%" });
    $("#content-mid").css({ width: "85%" });
    $(".left-menu a").css({
      "font-size": "0px",
      padding: "10px 30px",
      width: "70px",
    });
    $("#hide_menu, #show_menu").toggle();
    $(".tree").attr("hidden", "true");
  }

  function show(){
    $("#menu-left").css({ width: "20%" });
    $("#content-mid").css({ width: "75%" });
    $(".left-menu a").css({
      "font-size": "18px",
      padding: "10px 25px 10px 70px",
      width: "auto",
    });
    $("#hide_menu, #show_menu").toggle();
    $(".tree").removeAttr("hidden");
  }

  return (
      <div>
        <a href="javascript:void(0)" className="show-hide-Menu" id="hide_menu" onClick={hide}>
          Verberg
        </a>
        <a href="javascript:void(0)" className="show-hide-Menu" id="show_menu" onClick={show}>
          Toon
        </a>
      </div>
  );
};

export default Catalog;
